/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()
  new Swiper('.sp-swiper0', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
  })
  new Swiper('.sp-swiper-row', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
  })

  let spswiper0 = new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 4000,
    },
    spaceBetween: 10,

    on: {
      slideChange: function (e) {
        $('#swiper-btns .sp-swiper-option')
          .eq(e.realIndex)
          .addClass('active')
          .siblings()
          .removeClass('active')
      },
    },
    loop: true,
  })
  // 点击切换轮播
  $('#swiper-btns .sp-swiper-option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    spswiper0.slideTo($(this).index() + 1)
  })

  // jQuery(".sp-scroll").slide({
  //   mainCell: ".sp-nav-imgs",
  //   autoPlay: true,
  //   effect: "leftMarquee",
  //   interTime: 12,
  //   vis: 1,
  //   scroll: 1,
  // });
  let imgArr3 = [
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p1.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p2.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p3.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p4.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p5.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p1-1.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p1-2.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p1-3.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p1-4.png',
    'https://cdn.shopify.com/s/files/1/0827/3815/1744/files/202507092-p1-5.png',
  ]

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(imgArr3)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() + $('.sp-header-top').height() - 10
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }
  $('.sp-btn-pop').click(function () {
    $('.sp-mask').css('display', 'flex')
    $('.sp-pop').show()
  })

  mainRender()

  let prods = window.product
  function getCur(that) {
    let product_con = $(that).closest('.product-part')
    let color = product_con.find('#color div.active').attr('data-val')
    let size = product_con.find('#type div.active').attr('data-val')
    return prods.filter(
      item => item.option1 == size && item.option2 == color
    )[0]
  }
  function changePrice(that) {
    let product_con = $(that).closest('.product-part')
    let num = product_con.find('#calcNumber').val()
    let that1 = that
    let price = ((getCur(that1).price * num) / 100).toFixed(2)
    let compare = ((getCur(that1).compare_at_price * num) / 100).toFixed(2)
    if (price >= 50) {
      product_con.find('.btn-free').css('display', 'flex')
    } else {
      // $('.product-part .sp-tip').hide()
      product_con.find('.btn-free').hide()
    }
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
    product_con.find('#new').html(price)
    product_con.find('#old').html(compare)
    let off_font =
      100 -
      Math.ceil((getCur(that1).price / getCur(that1).compare_at_price) * 100)
    $('.product-part .price-group .sp-frees em').html(off_font)
  }
  $('.sp-btn-style').click(function () {
    let that = this
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur(that).id + ':' + num
  })
  // 数字框
  $('.reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    let that = this
    changePrice(that)
  })
  $('.add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    let that = this
    changePrice(that)
  })
  // style选项
  let typeOptions = $('#color .option')

  $('.option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    let that = this
    let index1 = $(that)
      .closest('.product-part')
      .find('#type div.active')
      .index()
    let index2 = $(that)
      .closest('.product-part')
      .find('#color div.active')
      .index()
    let index = index1 + index2 * 5
    $(that).closest('.product-part').find('.top-product img')[0].src =
      imgArr3[index]
    changePrice(that)
  })
  // style选项
  $('.cart-btn').click(function () {
    $(this).children('img').addClass('on')
    setTimeout(function () {
      $('.cart-btn').children('img').removeClass('on')
    }, 500)
    $('.sp-header-top .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-header-top .sp-cart').removeClass('on')
    }, 500)
  })
  // 加入购物车
  addCart()
  function addCart() {
    // 加入购物车
    $('.addCerts').click(function () {
      // do something here
      let that = this
      var data = {
        id: getCur(that).id,
        quantity: $(this).closest('.product-part').find('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $('.sp-cart .num').css('background', '#cf0101')
          })
        },
        dataType: 'json',
      })
      var img = $(this).closest('.product-part').find('.top-product img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $(this).closest('.product-part').append(flyer)
      $('.clone').css({
        width: img.width(),
        height: img.height(),
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99999',
      })
      var offset = $('.sp-cart')[0].getBoundingClientRect()
      $('.sp-cart').addClass('shake')
      setTimeout(() => {
        $('.sp-cart').removeClass('shake')
      }, 1000)
      let finish = $('.sp-cart')
      $('.clone').animate(
        {
          top: finish[0].offsetTop + 117,
          left: finish[0].offsetLeft + finish.width() / 2 - 15,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
  }
  // 关闭弹窗按钮

  $('.sp-pop .sp-close-btn').click(function (e) {
    $('.sp-mask').hide()
    $('.sp-pop2').hide()
    $('.sp-pop').hide()
  })
  $('.sp-pop2 .sp-close-btn').click(function (e) {
    $('.sp-mask').hide()
    $('.sp-pop2').hide()
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')
    const paragraph2 = gradually.querySelector('.sp-title-color')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            if (paragraph) {
              const totalDelay = spans.length * 0.1 + 0.3 + 0.5
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }
            // 段落
            if (paragraph2) {
              const totalDelay = spans.length * 0.1 + 0.3
              paragraph2.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph2.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // 弹幕效果
  const dmRows = document.querySelectorAll('.sp-dm-row')

  dmRows.forEach(row => {
    // 计算每行的总宽度
    let totalWidth = 0
    row.childNodes.forEach(child => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        totalWidth +=
          child.offsetWidth +
          parseInt(window.getComputedStyle(child).marginRight, 10)
      }
    })

    // 设置动态动画持续时间以保持匀速移动
    const speed = 110 // 可以调整速度，数值越大，速度越慢
    const duration = totalWidth / speed
    row.style.animationDuration = `${duration}s`

    row.addEventListener('animationiteration', () => {
      setTimeout(() => {
        row.style.transform = 'translateX(0)'
      }, duration)
    })
  })
})
